import { AdminAppRoute } from 'src/adminPanel/core/AdminAppRoute';
import { AppRoute } from 'src/core/AppRoute';
import ThumbCoffeehouseFranchise from 'src/resources/home/kaffeehaus-aussen.jpg';
import ThumbOfficeProfiFranchise from 'src/resources/home/office-profi.jpg';
import ImgAbo from 'src/resources/img-abo.png';
import ImgGastronomy from 'src/resources/img-gastronomy.jpg';
import ImgMission from 'src/resources/img-mission.jpg';
import ImgOffice from 'src/resources/img-office.jpg';
import ImgPrivate from 'src/resources/img-private.jpg';
import ImgQuality from 'src/resources/img-quality-roast.png';
import ImgService from 'src/resources/img-service.png';
import ImgMachines from 'src/resources/img-store-machines.png';
import ImgSustainability from 'src/resources/img-sustainability.jpg';
import ThumbImgAbo from 'src/resources/thumbs/img-abo.png';
import ThumbImgGastronomy from 'src/resources/thumbs/img-gastronomy.jpg';
import ThumbImgMission from 'src/resources/thumbs/img-mission.jpg';
import ThumbImgOffice from 'src/resources/thumbs/img-office.jpg';
import ThumbImgPrivate from 'src/resources/thumbs/img-private.jpg';
import ThumbImgQuality from 'src/resources/thumbs/img-quality-roast.png';
import ThumbImgService from 'src/resources/thumbs/img-service.png';
import ThumbImgMachines from 'src/resources/thumbs/img-store-machines.png';
import ThumbImgSustainability from 'src/resources/thumbs/img-sustainability.jpg';

/* Home Route */
export const ROUTE_HOME = new AppRoute('/', 'home');

/* Auto Login */
export const ROUTE_AUTO_LOGIN = new AppRoute('/auto-login', 'auto_login');

/* Shop Routes */
export const ROUTE_STORE = new AppRoute('/store', 'store');

export const ROUTE_STORE_PRODUCT_GROUP = ROUTE_STORE.sub(':productGroupSlug', 'products', {
    thumbnail: ThumbImgMachines, // TODO img for all products
    image: ImgMachines,
});

/* 
   Special shop routes where we want to link to directly 
   The slugs need to match the ones given by the product-groups endpoint
*/
export const ROUTE_STORE_PRODUCT_GROUP_ALL = ROUTE_STORE.sub('all', 'all_products', {
    thumbnail: ThumbImgMachines, // TODO img for all products
    image: ImgMachines,
});
export const ROUTE_PRODUCT_DETAILS = ROUTE_STORE.sub(':productGroupSlug/:id', 'product_details');
export const ROUTE_SUB_PRODUCT_DETAILS = ROUTE_PRODUCT_DETAILS.sub(':subid', 'sub_product_details');
export const ROUTE_ABO_OVERVIEW = ROUTE_STORE.sub('abo', 'abo_overview', {
    thumbnail: ThumbImgAbo,
    image: ImgAbo,
});
export const ROUTE_SERVICE_OVERVIEW = ROUTE_STORE.sub('service', 'service_overview', {
    thumbnail: ThumbImgService,
    image: ImgService,
});

export const ROUTE_CART = ROUTE_STORE.sub('cart', 'cart');
export const ROUTE_OFFER = ROUTE_STORE.sub('offer', 'offer');
export const ROUTE_DIRECTSELL = ROUTE_STORE.sub('directSell', 'offer', { accessPrivilege: 'DIRECT_SELLING' });
export const ROUTE_DIRECTSELL_CONFIRMATION = ROUTE_DIRECTSELL.sub('confirmation', 'confirmation');
export const ROUTE_CHECKOUT = ROUTE_CART.sub('checkout', 'checkout');
export const ROUTE_CONFIRMATION = ROUTE_CART.sub('confirmation', 'confirmation');

/* About Routes */
export const ROUTE_ABOUT = new AppRoute('/about', 'about');

export const ROUTE_MISSION = ROUTE_ABOUT.sub('mission', 'mission', {
    thumbnail: ThumbImgMission,
    image: ImgMission,
});
export const ROUTE_QUALITY = ROUTE_ABOUT.sub('quality', 'quality', {
    thumbnail: ThumbImgQuality,
    image: ImgQuality,
});
export const ROUTE_SUSTAINABILITY = ROUTE_ABOUT.sub('sustainability', 'sustainability', {
    thumbnail: ThumbImgSustainability,
    image: ImgSustainability,
});

export const GROUP_ABOUT: AppRoute[] = [ROUTE_MISSION, ROUTE_QUALITY, ROUTE_SUSTAINABILITY];

/* Special Routes for product packaging labels */
export const ROUTE_ABOUT_BEANS = ROUTE_ABOUT.sub('beans', 'beans');
export const ROUTE_ABOUT_BEANS_LUNGO = ROUTE_ABOUT_BEANS.sub('lungo', 'lungo');
export const ROUTE_ABOUT_BEANS_RISTRETTO = ROUTE_ABOUT_BEANS.sub('ristretto', 'ristretto');
export const ROUTE_ABOUT_BEANS_LOCA = ROUTE_ABOUT_BEANS.sub('loca', 'loca');
export const ROUTE_ABOUT_BEANS_BIO_LUNGO = ROUTE_ABOUT_BEANS.sub('biolungo', 'biolungo');
export const ROUTE_ABOUT_BEANS_BIO_LUNGO_DECAF = ROUTE_ABOUT_BEANS.sub('biolungodecaf', 'biolungodecaf');
export const ROUTE_ABOUT_BEANS_BIO_MEDITERRANEO = ROUTE_ABOUT_BEANS.sub('biomediterraneo', 'biomediterraneo');
export const ROUTE_ABOUT_BEANS_INTENSO = ROUTE_ABOUT_BEANS.sub('intenso', 'intenso');

/* Services Routes */
export const ROUTE_SERVICES = new AppRoute('/services', 'services');

export const ROUTE_OFFICE = ROUTE_SERVICES.sub('office', 'office', { thumbnail: ThumbImgOffice, image: ImgOffice });
export const ROUTE_GASTRONOMY = ROUTE_SERVICES.sub('gastronomy', 'gastronomy', {
    thumbnail: ThumbImgGastronomy,
    image: ImgGastronomy,
});
export const ROUTE_PRIVATE = ROUTE_SERVICES.sub('private', 'private', {
    thumbnail: ThumbImgPrivate,
    image: ImgPrivate,
});

// R16 item 12 / Q811 = B: "Für Unternehmen" — the two industry pages and the two franchise pages of the reference
export const ROUTE_COFFEEHOUSE_FRANCHISE = ROUTE_SERVICES.sub('kaffeehaus-franchise', 'coffeehouse_franchise', {
    thumbnail: ThumbCoffeehouseFranchise,
    image: ThumbCoffeehouseFranchise,
});
export const ROUTE_OFFICE_PROFI_FRANCHISE = ROUTE_SERVICES.sub('office-profi-franchise', 'office_profi_franchise', {
    thumbnail: ThumbOfficeProfiFranchise,
    image: ThumbOfficeProfiFranchise,
});
export const GROUP_SERVICES: AppRoute[] = [
    ROUTE_OFFICE,
    ROUTE_GASTRONOMY,
    ROUTE_COFFEEHOUSE_FRANCHISE,
    ROUTE_OFFICE_PROFI_FRANCHISE,
];

/* Contact Route */
export const ROUTE_CONTACT = new AppRoute('/contact', 'contact');

/* Hidden direct-link video route (no menu entry) */
export const ROUTE_VIDEO = new AppRoute('/video/:videoKey', 'video');

/* Impressum Route */
export const ROUTE_IMPRINT = new AppRoute('/imprint', 'imprint');

/* Privacy Policy Route */
export const ROUTE_PRIVACYPOLICY = new AppRoute('/privacy-policy', 'privacypolicy');

/* Agb Route */
export const ROUTE_AGB = new AppRoute('/agb', 'agb');

/* Cookies Route */
export const ROUTE_COOKIES = new AppRoute('/cookies', 'cookies');

export const GROUP_STATICS = [ROUTE_IMPRINT, ROUTE_AGB, ROUTE_PRIVACYPOLICY, ROUTE_COOKIES];

/* Register Route */
export const ROUTE_REGISTER = new AppRoute('/register', 'register');
export const ROUTE_REGISTER_CONFIRM = ROUTE_REGISTER.sub('confirm', 'confirm');
export const ROUTE_REGISTER_CONFIRMED = ROUTE_REGISTER.sub('confirmed', 'confirmed');

/* R63: Mitarbeiterchip self-registration from the chip invite link (production page of master 545addce4) */
export const ROUTE_VENDING_REGISTER = new AppRoute('/vending-registration', 'r63_vending.registration');
export const ROUTE_VENDING_REGISTER_CONFIRMED = ROUTE_VENDING_REGISTER.sub(
    'confirmed',
    'r63_vending.registration_confirmed'
);

/* System Route */
export const ROUTE_SYSTEM = new AppRoute('/system', 'system');

/* Admin Panel Routes */
export const ROUTE_ADMIN = new AdminAppRoute('/admin', 'admin', { accessPrivilege: 'ADMIN' });

/* Admin Panel V2 Route */
export const ROUTE_ADMINPANEL = new AdminAppRoute('/adminpanel', 'adminpanel', { accessPrivilege: 'ADMIN' });

/* Admin Panel - Office Routes */
export const ROUTE_ADMIN_OFFICE = new AdminAppRoute(ROUTE_ADMIN.path + '/office', ROUTE_ADMIN.t_key + '.front_office', {
    accessPrivilege: 'FrontOffice',
});
export const ROUTE_ADMIN_OFFICE_CUSTOMERS = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE.path + '/customers',
    ROUTE_ADMIN_OFFICE.t_key + '.customers'
);
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE.path + '/customerProfile',
    ROUTE_ADMIN_OFFICE.t_key + '.customer_profile'
);

export const ROUTE_ADMIN_OFFICE_ADDRESS_CONFIRMATION = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE.path + '/addressConfirmation',
    ROUTE_ADMIN_OFFICE.t_key + '.address_confirmation'
);

export const ROUTE_ADMIN_OFFICE_CONFIRMATION = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE.path + '/confirmation',
    ROUTE_ADMIN_OFFICE.t_key + '.confirmation'
);

export const ROUTE_ADMIN_OFFICE_DOWNLOAD_MANAGEMENT = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE.path + '/downloadManagement',
    ROUTE_ADMIN_OFFICE.t_key + '.download_management'
);

export const ROUTE_ADMIN_OFFICE_CALENDAR = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE.path + '/calendar',
    ROUTE_ADMIN_OFFICE.t_key + '.calendar'
);

export const ROUTE_ADMIN_OFFICE_CALENDAR_OVERVIEW = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CALENDAR.path + '/overview',
    ROUTE_ADMIN_OFFICE_CALENDAR.t_key + '_routes.overview'
);

export const ROUTE_ADMIN_OFFICE_CALENDAR_TRAINING = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CALENDAR.path + '/training',
    ROUTE_ADMIN_OFFICE_CALENDAR.t_key + '_routes.training'
);

export const ROUTE_ADMIN_OFFICE_CALENDAR_COMMISSION_MODEL = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CALENDAR.path + '/commission',
    ROUTE_ADMIN_OFFICE_CALENDAR.t_key + '_routes.commission'
);

export const ROUTE_ADMIN_OFFICE_CALENDAR_LOCATION = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CALENDAR.path + '/location',
    ROUTE_ADMIN_OFFICE_CALENDAR.t_key + '_routes.location'
);

export const ROUTE_ADMIN_OFFICE_CALENDAR_LANGUAGE = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CALENDAR.path + '/language',
    ROUTE_ADMIN_OFFICE_CALENDAR.t_key + '_routes.language'
);

export const ROUTE_ADMIN_OFFICE_LANDING_PAGES_MANAGEMENT = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE.path + '/landingPagesManagement',
    ROUTE_ADMIN_OFFICE.t_key + '.landing_pages_management'
);

export const ROUTE_ADMIN_OFFICE_ABO_TEMPLATES = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE.path + '/aboTemplates',
    ROUTE_ADMIN_OFFICE.t_key + '.abo_templates'
);

export const ROUTE_ADMIN_OFFICE_MITARBEITERCHIP = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE.path + '/mitarbeiterchip',
    ROUTE_ADMIN_OFFICE.t_key + '.mitarbeiterchip'
);

export const ROUTE_ADMIN_OFFICE_COFFEE_LEADS_EXPORT = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE.path + '/coffeeLeadsExport',
    ROUTE_ADMIN_OFFICE.t_key + '.coffee_leads_export'
);

export const ROUTE_ADMIN_OFFICE_MITARBEITERCHIP_ORG_DETAIL = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_MITARBEITERCHIP.path + '/:orgId',
    ROUTE_ADMIN_OFFICE.t_key + '.mitarbeiterchip_org_detail'
);

/* Admin Panel - Office Routes - Customer-Profile Routes */
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_OVERVIEW = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/overview',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.overview'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DATA_MAIN = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_OVERVIEW.path + '/main',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_OVERVIEW.t_key + '.main'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DATA_DOCUMENTS = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_OVERVIEW.path + '/documents',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_OVERVIEW.t_key + '.documents'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DATA_ADDRESSES = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_OVERVIEW.path + '/addresses',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_OVERVIEW.t_key + '.addresses'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DATA_PAYMENT_METHODS = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_OVERVIEW.path + '/paymentMethods',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_OVERVIEW.t_key + '.payment_methods'
);

export const GROUP_ADMIN_OFFICE_CUSTOMER_PROFILE_DATA: AdminAppRoute[] = [
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DATA_MAIN,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DATA_DOCUMENTS,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DATA_ADDRESSES,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DATA_PAYMENT_METHODS,
];

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_PARTNER = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/partner',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.partner'
);
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORDER = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/ordering',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.order'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORDERVIEW = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/order-overview',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.order_overview'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_CREDITS = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/credits',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.credits'
);
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_CHIPS = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/chips',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.chips'
);
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_SERVICE_APPLIANCES = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/service/appliances',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.service.appliances'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_SUCCESS_LIST = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/success-list',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.success_list'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_SUCCESS_LIST_OVERVIEW = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_SUCCESS_LIST.sub(
    'overview',
    'admin.front_office.customer_profile.success_list_overview'
) as AdminAppRoute;

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_SUCCESS_LIST_TOPICS_GROUP = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_SUCCESS_LIST.sub(
    ':successListTopic',
    'admin.front_office.customer_profile.success_list_topics'
) as AdminAppRoute;

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ACADEMIE = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/academie',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.academie'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/downloads',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.downloads'
);
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS_INFO_TOPIC = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS.sub(
    ':topic',
    'admin.front_office.customer_profile.downloads_info_topic'
) as AdminAppRoute;

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS_INFORMATION = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS.path + '/information',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS.t_key + '_information'
);
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS_COMMISSION_INVOICES = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS.path + '/commission-invoices',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS.t_key + '_commission_invoices'
);
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS_INVOICES = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS.path + '/invoices',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS.t_key + '_invoices'
);

export const GROUP_ADMIN_CUSTOMER_PROFILE_DOWNLOADS_ARRAY: AdminAppRoute[] = [
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS_INFORMATION,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS_COMMISSION_INVOICES,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_DOWNLOADS_INVOICES,
];

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_VIDEOS = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/videos',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.videos'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_VIDEOS_TOPICS_GROUP = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_VIDEOS.sub(
    ':videoTopic',
    'admin.front_office.customer_profile.video_topics'
) as AdminAppRoute;

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_LANDING_PAGES = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/landingpages',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.landingpages'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_PARTNER_DATA = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/partnerdata',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.partnerdata'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_LANDING_PAGES_OVERVIEW = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_LANDING_PAGES.sub(
    'overview',
    'overview'
);
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_LANDING_PAGES_OWN = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_LANDING_PAGES.sub(
    ':owner',
    'own'
);

export const GROUP_ADMIN_CUSTOMER_PROFILE_LANDINGPAGES_ARRAY: AdminAppRoute[] = [
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_LANDING_PAGES_OVERVIEW,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_LANDING_PAGES_OWN,
];

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_LANDINGPAGE_DETAILS = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_LANDING_PAGES_OWN.sub(
    ':lp',
    'account_landingpage_details'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_LANDINGPAGE_DETAILS_TABS = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_LANDINGPAGE_DETAILS.sub(
    ':tab',
    'account_landingpage_details_tabs'
);

/* Organization */
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/organization',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.organization'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION_OVERVIEW = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION.sub(
    'overview',
    'admin.front_office.customer_profile.organization_overview'
) as AdminAppRoute;
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION_CUSTOMERS = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION.sub(
    'customers',
    'admin.front_office.customer_profile.organization_customers'
) as AdminAppRoute;
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION_SIS_PARTNERS = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION.sub(
    'sis-partners',
    'admin.front_office.customer_profile.organization_sis_partners'
) as AdminAppRoute;
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION_OFFICE_PROFIS = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION.sub(
    'office_profis',
    'admin.front_office.customer_profile.organization_office_profis'
) as AdminAppRoute;
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION_LICENSORS = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION.sub(
    'licensors',
    'admin.front_office.customer_profile.organization_licensors'
) as AdminAppRoute;
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION_PLACEMENTS = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION.sub(
    'placements',
    'admin.front_office.customer_profile.organization_placements'
) as AdminAppRoute;

export const GROUP_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION = [
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION_OVERVIEW,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION_CUSTOMERS,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION_SIS_PARTNERS,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION_OFFICE_PROFIS,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION_LICENSORS,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_ORGANIZATION_PLACEMENTS,
];

/* Commission */
export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_COMMISSION = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/commission',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.commission'
);

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_COMMISSION_STATS = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_COMMISSION.sub(
    'stats',
    'admin.front_office.customer_profile.commission_stats'
) as AdminAppRoute;

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_COMMISSION_CHART = ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_COMMISSION.sub(
    'chart',
    'admin.front_office.customer_profile.commission_chart'
) as AdminAppRoute;

export const GROUP_ADMIN_OFFICE_CUSTOMER_PROFILE_COMMISSIONS = [
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_COMMISSION,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_COMMISSION_STATS,
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_COMMISSION_CHART,
];

export const GROUP_ADMIN_OFFICE_CUSTOMER_PROFILE_VIDEOS: AdminAppRoute[] = [
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_VIDEOS_TOPICS_GROUP,
];

export const GROUP_ADMIN_OFFICE_CUSTOMER_PROFILE_SERVICES: AdminAppRoute[] = [
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_SERVICE_APPLIANCES,
];

export const ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE_MANAGEMENT = new AdminAppRoute(
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.path + '/management',
    ROUTE_ADMIN_OFFICE_CUSTOMER_PROFILE.t_key + '.management'
);

/* Admin Panel - Article Management Routes */
export const ROUTE_ADMIN_ARTICLE_MANAGEMENT = new AdminAppRoute(
    ROUTE_ADMIN.path + '/article_management',
    ROUTE_ADMIN.t_key + '.article_management',
    { accessPrivilege: 'FrontOffice' }
);

export const ROUTE_ADMIN_ARTICLE_MANAGEMENT_ARTICLE = new AdminAppRoute(
    ROUTE_ADMIN_ARTICLE_MANAGEMENT.path + '/article',
    ROUTE_ADMIN_ARTICLE_MANAGEMENT.t_key + '.article'
);

export const ROUTE_ADMIN_ARTICLE_MANAGEMENT_ARTICLE_GROUP = new AdminAppRoute(
    ROUTE_ADMIN_ARTICLE_MANAGEMENT.path + '/articleGroup',
    ROUTE_ADMIN_ARTICLE_MANAGEMENT.t_key + '.articleGroup'
);

export const ROUTE_ADMIN_ARTICLE_MANAGEMENT_COMMISSION_MODEL = new AdminAppRoute(
    ROUTE_ADMIN_ARTICLE_MANAGEMENT.path + '/commissionModel',
    ROUTE_ADMIN_ARTICLE_MANAGEMENT.t_key + '.commissionModel'
);

export const ROUTE_ADMIN_ARTICLE_MANAGEMENT_PRODUCT_GROUP = new AdminAppRoute(
    ROUTE_ADMIN_ARTICLE_MANAGEMENT.path + '/productGroup',
    ROUTE_ADMIN_ARTICLE_MANAGEMENT.t_key + '.adminProductGroup'
);

/* Admin Panel - Service Routes */
export const ROUTE_ADMIN_SERVICE = new AdminAppRoute(ROUTE_ADMIN.path + '/service', ROUTE_ADMIN.t_key + '.service', {
    accessPrivilege: 'Service',
});

export const ROUTE_ADMIN_SERVICE_REPAIR_OFFER = new AdminAppRoute(
    ROUTE_ADMIN_SERVICE.path + '/repair-offer',
    ROUTE_ADMIN_SERVICE.t_key + '.repair-offer'
);

export const ROUTE_ADMIN_SERVICE_REPAIR_ORDER = new AdminAppRoute(
    ROUTE_ADMIN_SERVICE.path + '/repair-order',
    ROUTE_ADMIN_SERVICE.t_key + '.repair-order'
);
export const ROUTE_ADMIN_SERVICE_SERVICE_COMPLAINTS = new AdminAppRoute(
    ROUTE_ADMIN_SERVICE.path + '/service-complaints',
    ROUTE_ADMIN_SERVICE.t_key + '.service-complaints'
);

export const ROUTE_ADMIN_SERVICE_SERVICE_DRIVE = new AdminAppRoute(
    ROUTE_ADMIN_SERVICE.path + '/service-drive',
    ROUTE_ADMIN_SERVICE.t_key + '.service-drive'
);

export const ROUTE_ADMIN_SERVICE_MACHINE_DEPLOYMENT = new AdminAppRoute(
    ROUTE_ADMIN_SERVICE.path + '/machine-deployment',
    ROUTE_ADMIN_SERVICE.t_key + '.machine-deployment'
);

export const ROUTE_ADMIN_SERVICE_REPAIR_MANAGEMENT_1 = new AdminAppRoute(
    ROUTE_ADMIN_SERVICE.path + '/repair-management-1',
    ROUTE_ADMIN_SERVICE.t_key + '.repair-management-1'
);

export const ROUTE_ADMIN_SERVICE_REPAIR_MANAGEMENT_2 = new AdminAppRoute(
    ROUTE_ADMIN_SERVICE.path + '/repair-management-2',
    ROUTE_ADMIN_SERVICE.t_key + '.repair-management-2'
);

export const ROUTE_ADMIN_SERVICE_REPAIR_MANAGEMENT_3 = new AdminAppRoute(
    ROUTE_ADMIN_SERVICE.path + '/repair-management-3',
    ROUTE_ADMIN_SERVICE.t_key + '.repair-management-3'
);

/* Admin Panel - IT Routes */
export const ROUTE_ADMIN_IT = new AdminAppRoute(ROUTE_ADMIN.path + '/it', ROUTE_ADMIN.t_key + '.it', {
    accessPrivilege: 'IT',
});

export const ROUTE_ADMIN_IT_MAILS = new AdminAppRoute(ROUTE_ADMIN_IT.path + '/mails', ROUTE_ADMIN_IT.t_key + '.mails');

export const ROUTE_ADMIN_IT_VIDEOS = new AdminAppRoute(
    ROUTE_ADMIN_IT.path + '/videos',
    ROUTE_ADMIN_IT.t_key + '.videos'
);

export const ROUTE_ADMIN_IT_BARCODE_SCANNER = new AdminAppRoute(
    ROUTE_ADMIN_IT.path + '/barcodeScanner',
    ROUTE_ADMIN_IT.t_key + '.barcodeScanner'
);

export const ROUTE_ADMIN_IT_MARKETING_TEXTBLOCKS = new AdminAppRoute(
    ROUTE_ADMIN_IT.path + '/marketingTextBlocks',
    ROUTE_ADMIN_IT.t_key + '.marketingTextBlocks'
);

export const ROUTE_ADMIN_IT_MARKETING_DOCUMENTS = new AdminAppRoute(
    ROUTE_ADMIN_IT.path + '/marketingDocuments',
    ROUTE_ADMIN_IT.t_key + '.marketingDocuments'
);

export const ROUTE_ADMIN_IT_NO_PAYOUT_RATIONALE = new AdminAppRoute(
    ROUTE_ADMIN_IT.path + '/noPayoutRationalePage',
    ROUTE_ADMIN_IT.t_key + '.noPayoutRationalePage'
);

export const ROUTE_ADMIN_IT_ORDER_NOTE_SUBJECTS = new AdminAppRoute(
    ROUTE_ADMIN_IT.path + '/orderNoteSubjects',
    ROUTE_ADMIN_IT.t_key + '.orderNoteSubjects'
);

/* Admin Panel - Offsetting (=Verrechnung) Routes */
export const ROUTE_ADMIN_OFFSETTING = new AdminAppRoute(
    ROUTE_ADMIN.path + '/offsetting',
    ROUTE_ADMIN.t_key + '.offsetting',
    {
        accessPrivilege: 'Verrechnung',
    }
);

export const ROUTE_ADMIN_OFFSETTING_ORDERS = new AdminAppRoute(
    ROUTE_ADMIN_OFFSETTING.path + '/orders',
    ROUTE_ADMIN_OFFSETTING.t_key + '.orders'
);

export const ROUTE_ADMIN_OFFSETTING_ORDERS_TABS = ROUTE_ADMIN_OFFSETTING_ORDERS.sub(
    ':filterId',
    'admin.offsetting.filter'
) as AdminAppRoute;

export const ROUTE_ADMIN_OFFSETTING_COMMISSION_INVOICES = new AdminAppRoute(
    ROUTE_ADMIN_OFFSETTING.path + '/commissionInvoices',
    ROUTE_ADMIN_OFFSETTING.t_key + '.commissionInvoices'
);

export const ROUTE_ADMIN_OFFSETTING_COMMISSION_INVOICE_TABS = ROUTE_ADMIN_OFFSETTING_COMMISSION_INVOICES.sub(
    ':filterId',
    'admin.offsetting.filter'
) as AdminAppRoute;

export const ROUTE_ADMIN_OFFSETTING_ADYEN_BATCH = new AdminAppRoute(
    ROUTE_ADMIN_OFFSETTING.path + '/adyenBatch',
    ROUTE_ADMIN_OFFSETTING.t_key + '.adyenBatch'
);

export const ROUTE_ADMIN_OFFSETTING_SEPA = new AdminAppRoute(
    ROUTE_ADMIN_OFFSETTING.path + '/sepa',
    ROUTE_ADMIN_OFFSETTING.t_key + '.sepa'
);

export const ROUTE_ADMIN_PAYPAL_BATCH = new AdminAppRoute(
    ROUTE_ADMIN_OFFSETTING.path + '/paypalBatch',
    ROUTE_ADMIN_OFFSETTING.t_key + '.paypalBatch'
);

export const ROUTE_ADMIN_SEPA_BATCH = new AdminAppRoute(
    ROUTE_ADMIN_OFFSETTING.path + '/sepaBatch',
    ROUTE_ADMIN_OFFSETTING.t_key + '.sepaBatch'
);

export const ROUTE_ADMIN_MOLLIE_BATCH = new AdminAppRoute(
    ROUTE_ADMIN_OFFSETTING.path + '/mollieBatch',
    ROUTE_ADMIN_OFFSETTING.t_key + '.mollieBatch'
);

/* Coffeehouse Riga Landing Page */
export const ROUTE_COFFEEHOUSE_RIGA = new AppRoute('/coffeehouse/riga', 'coffeehouse_riga');
export const ROUTE_COFFEEHOUSE_RIGA_IMPRINT = ROUTE_COFFEEHOUSE_RIGA.sub('imprint', 'coffeehouse_riga_imprint');
export const ROUTE_COFFEEHOUSE_RIGA_PRIVACY = ROUTE_COFFEEHOUSE_RIGA.sub('privacy', 'coffeehouse_riga_privacy');

export const ROUTE_COFFEEHOUSE_VOUCHER_CONFIRMED = new AppRoute(
    '/coffeehouse/voucher-confirmed',
    'coffeehouse_voucher_confirmed'
);

/* Coffeehouse Riga 50 % Landing Page */
export const ROUTE_COFFEEHOUSE_RIGA_50 = new AppRoute('/coffeehouse/riga-50', 'coffeehouse_riga_50');
export const ROUTE_COFFEEHOUSE_RIGA_50_VOUCHER_CONFIRMED = ROUTE_COFFEEHOUSE_RIGA_50.sub(
    'voucher-confirmed',
    'coffeehouse_riga_50_voucher_confirmed'
);
